/* Product grid price alignment — single idempotent deferred asset.
 * Replaces per-card inline scripts to avoid duplicate global declarations
 * and repeated resize listeners. Safe to load once per page. */
(function () {
  'use strict';

  if (window.__productGridAlignmentInit) {
    return;
  }
  window.__productGridAlignmentInit = true;

  function alignProductGridPrices() {
    var productItems = document.querySelectorAll('.product-item[data-shows-compare-price]');
    if (productItems.length === 0) {
      return;
    }

    productItems.forEach(function (item) {
      var priceListEl = item.querySelector('.product-item__price-list');
      if (priceListEl) {
        priceListEl.classList.remove('price-list--needs-offset');
      }
    });

    var rows = {};
    var tolerance = 10;

    productItems.forEach(function (item) {
      var itemRect = item.getBoundingClientRect();
      var offsetTop = Math.round((itemRect.top + window.pageYOffset) / tolerance) * tolerance;
      if (!rows[offsetTop]) {
        rows[offsetTop] = [];
      }
      rows[offsetTop].push(item);
    });

    Object.keys(rows).forEach(function (offsetKey) {
      var currentRowItems = rows[offsetKey];
      var rowHasItemWithComparePrice = false;
      var rowHasItemWithoutComparePrice = false;

      currentRowItems.forEach(function (item) {
        if (item.dataset.showsComparePrice === 'true') {
          rowHasItemWithComparePrice = true;
        } else {
          rowHasItemWithoutComparePrice = true;
        }
      });

      if (rowHasItemWithComparePrice && rowHasItemWithoutComparePrice) {
        currentRowItems.forEach(function (item) {
          if (item.dataset.showsComparePrice === 'false') {
            var priceListEl = item.querySelector('.product-item__price-list');
            if (priceListEl) {
              priceListEl.classList.add('price-list--needs-offset');
            }
          }
        });
      }
    });
  }

  function init() {
    alignProductGridPrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var resizeDebounceTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeDebounceTimer);
    resizeDebounceTimer = setTimeout(alignProductGridPrices, 250);
  });

  window.alignProductGridPrices = alignProductGridPrices;
})();
